import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Logo from "../../Assets/Images/header/logo.png";
import Pointer from "../../Assets/Images/header/navPointer.png";
import NavBtn from "../../Assets/Images/header/nav.png";
//import EngBtnOn from "../../Assets/Images/header/engOn.png";
//import EngBtnOff from "../../Assets/Images/header/engOff.png"
//import ChiBtnOn from "../../Assets/Images/header/chiOn.png";
//import ChiBtnOff from "../../Assets/Images/header/chiOff.png";
import NavTabSelection from "../../Assets/Images/header/navTabSelection.png";
import FacebookIcon from "../../Assets/Images/header/facebookIcon.png";
import InstagramIcon from "../../Assets/Images/header/instagramIcon.png";
import GmailIcon from "../../Assets/Images/header/gmailIcon.png";
import PhoneIcon from "../../Assets/Images/header/phoneIcon.png";
import Language from "../../Components/languageComponent/language";

//const EngButton = {eng: EngBtnOn, chi: EngBtnOff};
//const ChiButton = {eng: ChiBtnOff, chi: ChiBtnOn};

//size variable content
//const siteName = {landscape: "Methodist Crisis Relief and Development", portrait: "MCRD"};
const navTabTop = { prepared: { landscape: "12.3vw", portrait: "20vw" }, unprepared: { landscape: "-100vh", portrait: "-100vh" } };
const navTabSelectionLeft = { 0: "140px", 1: "340px", 2: "540px", 3: "740px" };
const navPointerTop = { prepared: "-2vw", unprepared: "10000px" };
const navPointerPos = { 0: "20vw", 1: "37vw", 2: "54vw", 3: "71vw" };
//nav scroll pos
//about us
const navHistoryPos = { landscape: 10, portrait: 10 };
const navWhoWeAreScrollPos = { landscape: 450, portrait: 590 };
const navPurposePos = { landscape: 900, portrait: 1200 };
const navArchitecturePos = { landscape: 1357, portrait: 1700 };
const navStrategyPos = { landscape: 3620, portrait: 3670 };
//ministry
const navOngoingMinistryPos = { landscape: 10, portrait: 10 };
const navMalaysiaMinistryPos = { landscape: 680, portrait: 687 };
const navInternationalMinistryPos = { landscape: 2490, portrait: 2846 };
const navCovid19MinistryPos = { landscape: 5073, portrait: 5907 };
const navPublicationsPos = { landscape: 9500, portrait: 10800 };
//getInvolved
const navPrayerSupportPos = { landscape: 0, portrait: 0 };
const navOfferingSupportPos = { landscape: 582, portrait: 198 };

//size variable classname
//const header = {landscape: "headerLand", portrait: "headerPort"};
//const siteNameClass = {landscape: "siteName-land", portrait: "siteName-port"};
const pageNavClass = { landscape: "pageNav-land", portrait: "pageNav-port" };
const navTabClass = { landscape: "navTab-land", portrait: "navTab-port" };
const navTabChildClass = { on: "navTabChildOn", off: "navTabChildOff" };

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { language: "eng", navigation: "unprepared", navTab: 10 };
  }
  componentDidMount() {
    //this.props.updateHeight(this.header.clientHeight);
    window.addEventListener("scroll", this.listenScrollEvent);
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  render() {
    return (
      <div className="header" ref={(header) => (this.header = header)}>
        <header>
          {/*logo*/}
          <div className="logo">
            <img style={{ width: "100%", height: "100%" }} src={Logo} alt="Logo" />
          </div>
          {/*sitename*/}
          {/*<div onClick={() => this.onNavigateToSection(0)}><Link to="/"><p className={siteNameClass[this.props.orientation]}>{siteName[this.props.orientation]}</p></Link></div>*/}
          {/*language setting*/}
          {/*<div className="language">
                    <nav>
                        <ul>
                            <li>
                                <div className="languageBtn" onClick={this.onEngClicked}>
                                    <img style={{ width: '30px', height: '30px'}} src={EngButton[this.state.language]} ale="engBtn" />
                                </div>
                            </li>
                            <li>
                                <div className="languageBtn" onClick={this.onChiClicked}>
                                <img style={{ width: '30px', height: '30px'}} src={ChiButton[this.state.language]} ale="chiBtn" />
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>*/}
          {/*donate button*/}
          <div className="donate">
            <Button varient="contained">Donate</Button>
          </div>
          {/*main navigation bar*/}
          <div className={pageNavClass[this.props.orientation]}>
            <div className="navButton" onClick={this.state.navigation != "prepared" ? () => this.onNavigatePrepared(10) : this.onNavigateUnprepared}>
              <img style={{ width: "8vw", height: "8vw" }} src={NavBtn} alt="NavBtn" />
            </div>
            <nav>
              <ul>
                <li>
                  <div className="navAboutUs" onMouseEnter={() => this.onNavigatePrepared(0)}>
                    <Language language={this.state.language} section="navAboutUs" />
                  </div>
                </li>
                <li>
                  <div className="navOurMinistries" onMouseEnter={() => this.onNavigatePrepared(1)}>
                    <Language language={this.state.language} section="navOurMinistries" />
                  </div>
                </li>
                <li>
                  <div className="navGetInvolved" onMouseEnter={() => this.onNavigatePrepared(2)}>
                    <Language language={this.state.language} section="navGetInvolved" />
                  </div>
                </li>
                <li>
                  <div className="navContactUs" onMouseEnter={() => this.onNavigatePrepared(3)}>
                    <Language language={this.state.language} section="navContactUs" />
                  </div>
                </li>
              </ul>
            </nav>
          </div>
          {/*nav divider*/}
          <div className="navDivider">
            <img
              className="navPointer"
              style={{
                top: navPointerTop[this.state.navigation],
                left: navPointerPos[this.state.navTab],
              }}
              src={Pointer}
              alt="navPointer"
            />
          </div>
          {/*sub navigation bar*/}
          <div className={navTabClass[this.props.orientation]} style={{ width: "100%", top: navTabTop[this.state.navigation][this.props.orientation] }} onMouseLeave={this.props.orientation == "landscape" ? this.onNavigateUnprepared : void 0}>
            {/*nav tab selection*/}
            {/*<div>
                        <img style={{position: 'absolute', left: this.props.orientation == 'landscape' ? navTabSelectionLeft[this.state.navTab] : '-1000px', width:'200px', height: '100%'}} src={NavTabSelection} alt="NavTabSelection"/>
                    </div>*/}
            {/*sub navigation tab 1*/}
            <div
              className="navTabHeader"
              style={{
                position: this.props.orientation == "landscape" ? "absolute" : "relative",
                left: this.props.orientation == "landscape" ? "-1000px" : "0px",
              }}
              onClick={() => (this.state.navTab != 0 ? this.onNavigatePrepared(0) : this.onNavigatePrepared(10))}
            >
              <Language language={this.state.language} section="navAboutUs" />
            </div>
            <nav className={this.state.navTab == 0 ? navTabChildClass["on"] : navTabChildClass["off"]}>
              <ul>
                <li>
                  <div className="navHistory" onMouseEnter={() => this.onNavigatePrepared(0)} onClick={() => this.onNavigateToSection(navHistoryPos[this.props.orientation])}>
                    <Link to="/AboutUs">
                      <Language language={this.state.language} section="navHistory" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navWhoWeAre" onMouseEnter={() => this.onNavigatePrepared(0)} onClick={() => this.onNavigateToSection(navWhoWeAreScrollPos[this.props.orientation])}>
                    <Link to="/AboutUs">
                      <Language language={this.state.language} section="navWhoWeAre" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navPurpose" onMouseEnter={() => this.onNavigatePrepared(0)} onClick={() => this.onNavigateToSection(navPurposePos[this.props.orientation])}>
                    <Link to="/AboutUs">
                      <Language language={this.state.language} section="navPurpose" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navArchitecture" onMouseEnter={() => this.onNavigatePrepared(0)} onClick={() => this.onNavigateToSection(navArchitecturePos[this.props.orientation])}>
                    <Link to="/AboutUs">
                      <Language language={this.state.language} section="navArchitecture" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navStrategy" onMouseEnter={() => this.onNavigatePrepared(0)} onClick={() => this.onNavigateToSection(navStrategyPos[this.props.orientation])}>
                    <Link to="/AboutUs">
                      <Language language={this.state.language} section="navStrategy" />
                    </Link>
                  </div>
                </li>
              </ul>
            </nav>
            {/*sub navigation tab 2*/}
            <div
              className="navTabHeader"
              style={{
                position: this.props.orientation == "landscape" ? "absolute" : "relative",
                left: this.props.orientation == "landscape" ? "-1000px" : "0px",
              }}
              onClick={() => (this.state.navTab != 1 ? this.onNavigatePrepared(1) : this.onNavigatePrepared(10))}
            >
              <Language language={this.state.language} section="navOurMinistries" />
            </div>
            <nav className={this.state.navTab == 1 ? navTabChildClass["on"] : navTabChildClass["off"]}>
              <ul>
                <li>
                  <div className="navMalaysia" onMouseEnter={() => this.onNavigatePrepared(1)} onClick={() => this.onNavigateToSection(navMalaysiaMinistryPos[this.props.orientation])}>
                    <Link to="/Ministries">
                      <Language language={this.state.language} section="navMalaysia" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navInternational" onMouseEnter={() => this.onNavigatePrepared(1)} onClick={() => this.onNavigateToSection(navInternationalMinistryPos[this.props.orientation])}>
                    <Link to="/Ministries">
                      <Language language={this.state.language} section="navInternational" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navCovid19" onMouseEnter={() => this.onNavigatePrepared(1)} onClick={() => this.onNavigateToSection(navCovid19MinistryPos[this.props.orientation])}>
                    <Link to="/Ministries">
                      <Language language={this.state.language} section="navCovid19" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navPublications" onMouseEnter={() => this.onNavigatePrepared(1)} onClick={() => this.onNavigateToSection(navPublicationsPos[this.props.orientation])}>
                    <Link to="/Ministries">
                      <Language language={this.state.language} section="navPublications" />
                    </Link>
                  </div>
                </li>
              </ul>
            </nav>
            {/*sub navigation tab 3*/}
            <div
              className="navTabHeader"
              style={{
                position: this.props.orientation == "landscape" ? "absolute" : "relative",
                left: this.props.orientation == "landscape" ? "-1000px" : "0px",
              }}
              onClick={() => (this.state.navTab != 2 ? this.onNavigatePrepared(2) : this.onNavigatePrepared(10))}
            >
              <Language language={this.state.language} section="navGetInvolved" />
            </div>
            <nav className={this.state.navTab == 2 ? navTabChildClass["on"] : navTabChildClass["off"]}>
              <ul>
                <li>
                  <div className="navMCRDVolunteer" onMouseEnter={() => this.onNavigatePrepared(2)}>
                    <a href="https://docs.google.com/forms/d/1qs6quRQ_QVYX-VOKZFOY4NLOrZVFZERELrOhuP4C6z0/viewform?edit_requested=true">
                      <Language language={this.state.language} section="navMCRDVolunteer" />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="navMAcademy" onMouseEnter={() => this.onNavigatePrepared(2)}>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdzz_qoKZvkxqipRZoLR6uPPD_zQQq6Qp4613Cnhtj7zUAejQ/viewform?fbclid=IwAR0sIfkoU7zkMGzaoGGi76n90-qvksYMbjJ6fXc4CTcpfRzrCB-UUBFunkA">
                      <Language language={this.state.language} section="navMAcademy" />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="navPrayerSupport" onMouseEnter={() => this.onNavigatePrepared(2)} onClick={() => this.onNavigateToSection(navPrayerSupportPos[this.props.orientation])}>
                    <Link to="/GetInvolved">
                      <Language language={this.state.language} section="navPrayerSupport" />
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="navOfferingSupport" onMouseEnter={() => this.onNavigatePrepared(2)} onClick={() => this.onNavigateToSection(navOfferingSupportPos[this.props.orientation])}>
                    <Link to="/GetInvolved">
                      <Language language={this.state.language} section="navOfferingSupport" />
                    </Link>
                  </div>
                </li>
              </ul>
            </nav>
            {/*sub navigation tab 4*/}
            <div
              className="navTabHeader"
              style={{
                position: this.props.orientation == "landscape" ? "absolute" : "relative",
                left: this.props.orientation == "landscape" ? "-1000px" : "0px",
              }}
              onClick={() => (this.state.navTab != 3 ? this.onNavigatePrepared(3) : this.onNavigatePrepared(10))}
            >
              <Language language={this.state.language} section="navContactUs" />
            </div>
            <nav className={this.state.navTab == 3 ? navTabChildClass["on"] : navTabChildClass["off"]}>
              <ul>
                <li>
                  <div className="navFBPage" onMouseEnter={() => this.onNavigatePrepared(3)}>
                    <a href="https://www.facebook.com/cacmcrd/?ref=page_internal">
                      <img src={FacebookIcon} style={{ width: "30px", height: "30px" }} alt="FacebookIcon" />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="navInstagram" onMouseEnter={() => this.onNavigatePrepared(3)}>
                    <a href="https://www.instagram.com/mcrdmalaysia/?r=nametag">
                      <img src={InstagramIcon} style={{ width: "30px", height: "30px" }} alt="InstagramIcon" />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="navGmail" onMouseEnter={() => this.onNavigatePrepared(3)}>
                    <a href="https://mail.google.com/mail/?view=cm&fs=1&to=mcrdmalaysia@gmail.com&su=SUBJECT&body=BODY&bcc=">
                      <img src={GmailIcon} style={{ width: "30px", height: "25px" }} alt="GmailIcon" />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="navContactNumber" onMouseEnter={() => this.onNavigatePrepared(3)}>
                    <img src={PhoneIcon} alt="PhoneIcon" />
                    03-2070 2501
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </header>
      </div>
    );
  }
  onEngClicked = (e) => {
    this.props.updateLanguage("eng");
    this.setState({ language: "eng" });
  };
  onChiClicked = (e) => {
    this.props.updateLanguage("chi");
    this.setState({ language: "chi" });
  };
  onNavigatePrepared = (e) => {
    this.setState({
      navigation: "prepared",
      navTab: e,
    });
  };
  onNavigateUnprepared = (e) => {
    this.setState({ navigation: "unprepared" });
  };
  onNavigateToSection = (e) => {
    this.setState({ navigation: "unprepared" });
    this.props.updateScrollPos(e);
  };
  resize() {
    if (window.innerWidth > window.innerHeight) this.setState({ navigation: "unprepared" });
    else this.setState({ navigation: "unprepared" });
  }
  listenScrollEvent = (e) => {
    if (this.props.orientation == "portrait") this.onNavigateUnprepared();
  };
}
export default Header;
